import { apiInstance } from "./ApiInstance";

export const uploadDocument = async (caseId, payload) => {
  const { data = {} } = await apiInstance.post(
    `/api/case/upload-case-documents/${caseId}`,
    payload
  );
  return data;
};
